export class TextUtils {
    public static isEmpty(text: string | undefined | null): boolean {
        return !text || 0 === text.length;
    }
}
